<template>
  <div id="grid-reporte">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text">
          Reporte validaciones
        </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsReporte"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.fechaIni }}</td>
                <td class="text-xs-left">{{ props.item.fechaFin }}</td>
                <td class="text-xs-left">
                  {{ (props.item.numHorasAsistencia / 60).toFixed(1) }} /
                  {{ props.item.numHoras * props.item.numPersonas }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.numPersonasAsistencia }} /
                  {{ props.item.numPersonas }}
                </td>
              </template>
            </v-data-table>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegs"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pages"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="botonDescarga"
                color="primary"
                @click="descarga()"
                >Descarga reporte</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-reporte",

  components: {
    AlertEmpty,
    Loading,
    LoadingDescarga,
  },

  data() {
    return {
      botonDescarga: false,
      loading: false,
      dialogLoading: false,
      alerta: false,
      idContrato: "",
      headers: [
        {
          text: "Fecha de inicio",
          align: "left",
          sortable: false,
          value: "Fecha",
        },
        { text: "Fecha de término", sortable: false, value: "termino" },
        { text: "No. de Horas", sortable: false, value: "Horas" },
        { text: "No. de personas", sortable: false, value: "personas" },
      ],
      usuarioLoggedTipe: "",
      itemsReporte: [],
      idUserLogged: "",

      //paginacion por DB
      page: 1,
      pages: 1,
      totalRegs: 0,
      rowsPerPageItems: [20],
    };
  },
  watch: {
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;

    this.idContrato = this.$store.getters.contratoStored;

    this.tab = this.$store.getters.subTabSelectedStored;

    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.codContrato = this.$store.getters.contratoCodStored;
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    descarga() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Descarga_reporte_validaciones.xlsx";

      var url = "/reporte/descargaReporte/";
      this.body = {
        idContrato: idContrato,
        idNivel: null,
        tipoPrueba: null,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.dialogLoading = false;
          return response.data;
        })
        .catch(function (error) {
          this.dialogLoading = false;
          console.log(error);
          return [];
        });
    },
    async verReporte() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/reporte/verReporte/", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      let result = await this.verReporte();
      this.itemsReporte = result.especificaciones;

      if (result.totalRegistros > 0) {
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
  },
};
</script>
